import { useState } from "react";
import { Link } from "react-router-dom";
import { AppLayout } from "../../components/layout/Header";
import TextInput from "../../components/forms/TextInput";
import { requestPasswordReset } from "../../js/auth/authOnboarding";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  function handleSubmit(event) {
    event.preventDefault();
    setError("");
    if (!email.trim()) {
      setError("Enter the email on your account.");
      return;
    }
    setResult(requestPasswordReset(email));
  }

  return (
    <AppLayout>
      <article className="card auth-card onboarding-card">
        <h1>Forgot password</h1>
        <p className="page-lead">We will queue a reset link for the email on your account.</p>
        <form onSubmit={handleSubmit}>
          <TextInput
            label="Email"
            name="email"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
          {error ? <p className="field-error">{error}</p> : null}
          <button type="submit" className="primary-btn btn-block">
            Send reset link
          </button>
        </form>
        {result ? (
          <div className="onboarding-dev-link">
            <p className="confirm">{result.message}</p>
            {result.resetUrl ? (
              <>
                <p className="muted">Until outbound mail is live, open this link on this device:</p>
                <a className="ghost-btn" href={result.resetUrl}>
                  Reset password
                </a>
              </>
            ) : null}
          </div>
        ) : null}
        <p className="muted">
          <Link to="/agent/login">Agent login</Link> · <Link to="/broker/login">Broker login</Link>
        </p>
      </article>
    </AppLayout>
  );
}
